export const PRICE = "OMR";